import { IStateSession } from '@libs/types';
import { isSupportMultiTabs } from './request/requestHelper';

const EMBEDDED_PLAYER_SESSIONS = 'embeddedPlayerSessions';

interface EmbeddedPlayerSession {
    auth?: IStateSession['auth'];
    isFillParent?: boolean;
}

interface EmbeddedPlayerSessions {
    [playerId: string]: EmbeddedPlayerSession;
}

const getEmbeddedPlayerSessions = (fromLocalStorage = false): EmbeddedPlayerSessions => {
    const sessions = (isSupportMultiTabs() ? (fromLocalStorage ? localStorage : sessionStorage) : localStorage)?.getItem(EMBEDDED_PLAYER_SESSIONS);
    return sessions ? JSON.parse(sessions) : {};
};

const setEmbeddedPlayerSessions = (newSessions: EmbeddedPlayerSessions): void => {
    if (isSupportMultiTabs()) {
        sessionStorage?.setItem(EMBEDDED_PLAYER_SESSIONS, JSON.stringify(newSessions));
    }
    const oldLSSessions = getEmbeddedPlayerSessions(true);
    localStorage?.setItem(EMBEDDED_PLAYER_SESSIONS, JSON.stringify({ ...oldLSSessions, ...newSessions }));
};

export const getEmbeddedPlayerSession = (playerId: string, isRequestInteraction = false): EmbeddedPlayerSession | undefined => {
    const sessionSS = getEmbeddedPlayerSessions()[playerId];
    const sessionLS = getEmbeddedPlayerSessions(true)[playerId];

    if (sessionSS) {
        return sessionSS;
    } else if (sessionLS && isRequestInteraction) {
        return { ...sessionLS, isFillParent: true };
    }
    return undefined;
};

export const setEmbeddedPlayerSession = (playerId: string, session: EmbeddedPlayerSession): void => {
    const sessions = getEmbeddedPlayerSessions();
    sessions[playerId] = session;
    setEmbeddedPlayerSessions(sessions);
};

export const clearEmbeddedPlayerSession = (playerId: string): void => {
    const sessions = getEmbeddedPlayerSessions();
    delete sessions[playerId];
    setEmbeddedPlayerSessions(sessions);
};

/** Locales passed to `embeddedPlayer.init({ locale })`, per player. In memory only: lives as long as the host page. */
const embeddedPlayerLocales = new Map<string, string>();

export const getEmbeddedPlayerLocale = (playerId: string): string | undefined => embeddedPlayerLocales.get(playerId);

export const setEmbeddedPlayerLocale = (playerId: string, locale: string): void => {
    embeddedPlayerLocales.set(playerId, locale);
};

export const clearEmbeddedPlayerLocale = (playerId: string): void => {
    embeddedPlayerLocales.delete(playerId);
};
